<div class="loader-slide center">
  <img src="/assets/images/loader.svg" class="spinner" alt="Loading" title="Loading" />
</div>
